module.exports = __webpack_public_path__ + "assets/img/c72ef9f32b5094f3df010fd0c2abe3e6.svg";